// Angular Import
import { Component, EventEmitter, NgIterable, Output, ChangeDetectionStrategy } from '@angular/core';
// import { FriendsList } from 'src/app/fack-db/friends-list';

@Component({
  selector: 'app-chat-user-list',
  templateUrl: './chat-user-list.component.html',
  styleUrls: ['./chat-user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatUserListComponent {
  @Output() ChatCollapse = new EventEmitter();
  @Output() ChatToggle = new EventEmitter();
  searchFriends!: string;
  // eslint-disable-next-line
  friendsList: NgIterable<any> | null | undefined;

  constructor() {
    // this.friendsList = FriendsList.friends;
    this.friendsList = [];
  }

  ChatOn() {
    this.ChatToggle.emit();
  }
}
